import { doc, getDoc, collection, getCountFromServer } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Extrai o userId do roomId e busca o nome público do terapeuta na coleção therapists
 * @param roomId - ID da sala (pode ser "sala-{userId}" ou diretamente o userId)
 * @returns Promise<string> - Nome público do terapeuta ou fallback "Terapeuta"
 */
export const getUserNameFromRoomId = async (roomId: string): Promise<string> => {
  try {
    // Extrai o userId do formato "sala-{userId}" ou "sala-{userId}-{appointmentId}".
    // Firebase UIDs não têm hífen — por isso não usamos só split('-')[1]
    // (quebrava salas como "sala-livekit-teste" → "livekit" → fallback "Terapeuta").
    let userId = roomId;
    if (roomId.startsWith('sala-')) {
      const rest = roomId.slice('sala-'.length);
      const uidMatch = rest.match(/^([A-Za-z0-9]{20,28})(?:-|$)/);
      userId = uidMatch ? uidMatch[1] : rest;
    }

    const therapistDoc = await getDoc(doc(db, 'therapists', userId));
    if (therapistDoc.exists()) {
      const therapistData = therapistDoc.data();
      const name =
        therapistData.nomePublico || therapistData.name || therapistData.displayName;
      if (name) return name;
    }

    const userDoc = await getDoc(doc(db, 'users', userId));
    if (userDoc.exists()) {
      const userData = userDoc.data();
      const name = userData.name || userData.displayName;
      if (name) return name;
    }

    return 'Terapeuta';
  } catch (error) {
    console.error('Erro ao buscar nome do terapeuta:', error);
    return 'Terapeuta';
  }
};

/**
 * Conta o número real de participantes em uma sala
 * @param roomId - ID da sala
 * @returns Promise<number> - Número de participantes ou 0 em caso de erro
 */
export const getParticipantCount = async (roomId: string): Promise<number> => {
  try {
    const participantsCollection = collection(db, 'rooms', roomId, 'participants');
    const countSnapshot = await getCountFromServer(participantsCollection);
    return countSnapshot.data().count;
  } catch (error) {
    console.error('Erro ao contar participantes da sala:', roomId, error);
    return 0;
  }
};